module.exports = __webpack_public_path__ + "img/companythree.8fa3f788.png";